import { makeStyles } from '@material-ui/core/styles'

export const commonStyles = makeStyles({
  toolbar: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between'
  }
})
